/* global jQuery globalSiteSettings Cookies */
(function ($) {
    $(document).ready(function () {
        var getQueryString = function (name) {
            // eslint-disable-next-line
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i'),
                results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };

        var urlPhoneNumber = getQueryString('phone');
        var replacementSettings = $('.lm-page-settings');

        replacementSettings.each(function (index, element) {
            element = $(element);
            var settingType = element.data('lmsettings');
            switch (settingType.toString().toLowerCase()) {
                case 'phone':
                    $.when(window.defTrackingInformation).done(function () {
                        setPhone(element);
                    });
                    break;
                case 'logo':
                    setLogo(element);
                    break;
                case 'partner':
                    setPartnerName(element);
                    break;
                case 'store':
                    setStoreName(element);
                    break;
                case 'sourcelocation':
                    setSourceLocation(element);
                    break;
                case 'source':
                    setSource(element);
                    break;
                case 'customphone':
                    setCustomPhoneNumber(element);
                    break;
                case 'applynow':
                    setCustomApplyNowText(element);
                    break;
                case 'applynowlink':
                    setCustomApplyNowLink(element);
                    break;
                default:
                    window.debugLog('data-lmsettings type not found - ' + settingType);
            }
        })

        function setPhone(element) {
            var setting = (typeof globalSiteSettings.setPhone != 'undefined') ? globalSiteSettings.setPhone : '';

            var cookiePhone = function () {
                var sessionCookie = Cookies.get('800LMTrackingSession');

                if (typeof sessionCookie === 'undefined')
                    return false;

                sessionCookie = $.deparam(sessionCookie);
                return sessionCookie['Phone'];
            }();

            if (urlPhoneNumber) {
                setting = urlPhoneNumber;
            } else if (cookiePhone) {
                setting = cookiePhone;
            } else if (!setting) {
                var cookieReferrerPhone = Cookies.get('pagesetting_referrerPhoneNumber');
                if (cookieReferrerPhone) {
                    setting = cookieReferrerPhone;
                } else {
                    setting = getOrganicPhone();
                    if (setting) {
                        Cookies.set('pagesetting_referrerPhoneNumber', setting);
                    }
                }
            }

            if (setting) {
                if (element.is('a')) {
                    element.attr('href', 'tel:' + setting);
                } else {
                    element.text(setting);
                }
            }
        }

        function setLogo(element) {
            var setting = (typeof globalSiteSettings.setLogo != 'undefined') ? globalSiteSettings.setLogo : '';
            if (setting) {
                element.attr('src', setting);
            }

            setting = '';
            if (setting) {
                element.attr('alt', setting);
            }

            setting = '';
            if (setting) {
                var parentElem = element.parent();
                if (parentElem.is('a')) {
                    parentElem.attr('href', setting);
                }
            }
        }

        function setPartnerName(element) {
            var setting = (typeof globalSiteSettings.setPartnerName != 'undefined') ? globalSiteSettings.setPartnerName : '';
            if (setting) {
                element.text(setting);
            }
        }

        function setStoreName(element) {
            var setting = (typeof globalSiteSettings.setStoreName != 'undefined') ? globalSiteSettings.setStoreName : '';
            if (setting) {
                element.text(setting);
            }
        }

        function setSourceLocation(element) {
            var setting = (typeof globalSiteSettings.setSourceLocation != 'undefined') ? globalSiteSettings.setSourceLocation : '';
            if (setting) {
                element.text(setting);
            }
        }

        function setSource(element) {
            var setting = (typeof globalSiteSettings.setSource != 'undefined') ? globalSiteSettings.setSource : '';
            if (setting) {
                element.text(setting);
            }
        }

        function setCustomPhoneNumber(element) {
            var setting = (typeof globalSiteSettings.setCustomPhoneNumber != 'undefined') ? globalSiteSettings.setCustomPhoneNumber : '';
            if (setting) {
                if (element.is('a')) {
                    element.attr('href', 'tel:' + setting);
                } else {
                    element.text(setting);
                }
            }
        }

        function setCustomApplyNowText(element) {
            var setting = (typeof globalSiteSettings.setCustomApplyNowText != 'undefined') ? globalSiteSettings.setCustomApplyNowText : '';
            if (setting) {
                element.text(setting);
            }

            if (element.is('a')) {
                var hrefSetting = '';
                if (hrefSetting) {
                    element.attr('href', hrefSetting);
                }
            }
        }

        function setCustomApplyNowLink(element) {
            var setting = (typeof globalSiteSettings.setCustomApplyNowLink != 'undefined') ? globalSiteSettings.setCustomApplyNowLink : '';
            if (setting) {
                if (element.is('a')) {
                    element.attr('href', setting);
                }
            }
        }

        function getOrganicPhone() {
            var organics = [
                'daum.net/',
                'eniro.se/',
                'naver.com/',
                'yahoo.com/',
                'msn.com/',
                'aol.com/',
                'lycos.com/',
                'ask.com/',
                'altavista.com/',
                'search.netscape.com/',
                'cnn.com/SEARCH/',
                'about.com/',
                'mamma.com/',
                'alltheweb.com/',
                'voila.fr/',
                'search.virgilio.it/',
                'baidu.com/',
                'alice.com/',
                'yandex.com/',
                'najdi.org.mk/',
                'aol.com/',
                'mamma.com/',
                'seznam.cz/',
                'search.com/',
                'wp.pl/',
                'online.onetcenter.org/',
                'szukacz.pl/',
                'yam.com/',
                'pchome.com/',
                'kvasir.no/',
                'sesam.no/',
                'ozu.es/',
                'terra.com/',
                'mynet.com/',
                'ekolay.net/',
                'rambler.ru/',
            ];

            var googleOrganics = [
                'www.google',
            ];

            var bingOrganics = [
                'bing.com/',
            ];

            if (isOrganic(googleOrganics)) {
                return '855-562-6355';
            } else if (isOrganic(bingOrganics)) {
                return '833-941-1607';
            } else if (isOrganic(organics)) {
                return '1-844-359-3967';
            } else {
                return '';
            }

            function isOrganic(searchEngines) {
                for (let index in searchEngines) {
                    if (document.referrer.indexOf(searchEngines[index]) > -1) {
                        return true;
                    }
                }

                return false;
            }
        }

        // Tracking cookie //TODO vars below not used!
        //var currentSource = (typeof globalSiteSettings.setSource != 'undefined') ? globalSiteSettings.setSource : ''
        //var currentSourceLocation = (typeof globalSiteSettings.setSourceLocation != 'undefined') ? globalSiteSettings.setSourceLocation : ''
        //var currentStoreKey = (typeof globalSiteSettings.setStoreKey != 'undefined') ? globalSiteSettings.setStoreKey : ''
        //if (urlPhoneNumber && !Cookies.get('pagesetting_urlPhoneNumber')) {
        //Cookies.set('pagesetting_urlPhoneNumber', urlPhoneNumber)
        //}

    });

})(jQuery);
